var $6931fa94eef7a6e6$exports = {};
$6931fa94eef7a6e6$exports = {
    "(optional)": `(\u{5D0}\u{5D5}\u{5E4}\u{5E6}\u{5D9}\u{5D5}\u{5E0}\u{5DC}\u{5D9})`,
    "(required)": `(\u{5E0}\u{5D3}\u{5E8}\u{5E9})`
};


export {$6931fa94eef7a6e6$exports as default};
//# sourceMappingURL=he-IL.mjs.map
